import { render, staticRenderFns } from "./HoneyMoonRecommend.vue?vue&type=template&id=15d86b61&"
import script from "./HoneyMoonRecommend.vue?vue&type=script&lang=js&"
export * from "./HoneyMoonRecommend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports